import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryButtons from "./components/CategoryButtons";
import ContentSection from "./components/ContentSection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryButtons />
        <ContentSection />
      </main>
      <Footer />
    </>
  );
}